<div *ngIf="isOpen" id="video-overlay" class="overlay open" (click)="closeVideo()">
  <div class="video-container" (click)="$event.stopPropagation()">
    <iframe width="996" height="560" [src]="videoUrl" title="YouTube video player" frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
    </iframe>
  </div>
  <a class="video-overlay-close" (click)="closeVideo()">×</a>
  <!-- <button class="video-overlay-close" (click)="closeVideo()">X</button> -->
</div>